enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}

enum MediaSource {
  FACEBOOK = 'FACEBOOK',
  SITE = 'SITE',
  UPLOAD = 'UPLOAD',
}

export { MediaSource, MediaType };
